import { render, staticRenderFns } from "./IndexFilter.vue?vue&type=template&id=6b866058&"
import script from "./IndexFilter.vue?vue&type=script&lang=js&"
export * from "./IndexFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports